import React from 'react'
import clsx from 'clsx'
import styled from '@emotion/styled'
import { Tooltip } from '@mantine/core'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import { IconMaps } from '@ow/icons'

const ListBox = styled.div`
  position: relative;

  .contain-title {
    padding: 10px 20px;
  }

  .field-list {
    height: calc(100% - 108px);
    overflow: auto;
    padding: 10px 0px 10px 20px;

    .list-item {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 10px 10px 10px 0;
      width: 100%;

      .list-bind {
        margin: 0px 10px;
        cursor: pointer;
        transition: visibility 0.3s, opacity 0.3s;
        visibility: hidden;
        opacity: 0;
        position: relative;

        .unlink-bg {
          background: #fdecee;
          border-radius: 4px;
          height: 28px;
          width: 28px;
        }
        .link-bg {
          background: #ecf2fe;
          border-radius: 4px;
          height: 28px;
          width: 28px;
        }

        .list-bind-normal {
          position: absolute;
          visibility: visible;
          opacity: 1;
        }
        .point-able {
          point-events: none;
          background: #edebeb;
          border-radius: 4px;
        }
        .list-bind-hover {
          transition: visibility 0.3s, opacity 0.3s;
          visibility: hidden;
          opacity: 0;
        }

        &:hover {
          .list-bind-normal {
            transition: visibility 0.3s, opacity 0.3s;
            visibility: hidden;
            opacity: 0;
          }
          .list-bind-hover {
            visibility: visible;
            opacity: 1;
          }
        }
      }

      &:hover {
        .list-bind {
          visibility: visible;
          opacity: 1;
        }
      }

      .list-contain {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 10px;
        width: calc(100% - 40px);
        border: 1px dashed #dcdcdc;
        cursor: move;

        &:hover {
          border: 1px dashed #ed7b2f;
          .list-delete {
            display: block;
            padding: 0px 10px;
          }
        }
        &.active {
          border: 1px dashed #ed7b2f;
          background: #fef3e6;
        }
        &.binding {
          border: 1px dashed #ed7b2f;
        }
      }

      .list-icon {
        padding: 0px 10px;
      }
      .list-text {
        width: calc(100% - 40px);
      }
    }
  }

  .add-field {
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 10px 20px;
    height: 64px;
    border-top: 1px solid #dcdcdc;
    width: 100%;
    cursor: pointer;
  }
`
// 解绑组件
const UnBindComp = (isShowUnBindIcon, onItemUnBind, fieldList, i) => {
  return isShowUnBindIcon ? (
    <div
      className="list-bind"
      onClick={() => {
        onItemUnBind(fieldList[i])
      }}
    >
      <div className="list-bind-normal">
        <IconMaps type="unLinkNormalIcon" size="md" />
      </div>
      <div className="list-bind-hover unlink-bg">
        <IconMaps type="unlinkIcon" size="md" />
      </div>
    </div>
  ) : null
}

/**
 * 字段列表组件
 * @param {string} className 样式
 * @param {array} fieldList 字段列表
 * @param {string} bindTip 控制是否置灰绑定图标显示绑定提示
 * @param {number} curFieldIndex 当前编辑索引
 * @param {number} currentBindIndex 当前绑定索引
 * @param {object} onBindFuns 绑定解绑相关方法
 * @param {function} onChangeOrder 当变更排序时
 * @param {function} onDragStart 当变更排序开始时
 * @param {function} onClickField 点击文件时执行的函数
 * @param {function} onOpenCreatePage 点击打开新建页时执行的函数
 * @returns
 */
const FieldsList = ({
  className,
  fieldList,
  bindTip,
  curFieldIndex,
  currentBindIndex,
  onBindFuns,
  onChangeOrder,
  onDragStart,
  onClickField,
  onOpenCreatePage,
}) => {
  const {
    onItemUnBind = () => {},
    onItemBind = () => {},
    isShowUnBindIcon,
  } = onBindFuns || {}

  return (
    <ListBox className={className}>
      <div className="contain-title">字段列表</div>
      <div className="field-list">
        <DragDropContext
          onDragStart={() => {
            onDragStart()
          }}
          onDragEnd={(result) => {
            if (!result.destination) {
              return
            }
            onChangeOrder(
              fieldList,
              result.source.index,
              result.destination.index
            )
          }}
        >
          <Droppable droppableId="droppable">
            {(firstProvided) => (
              <div
                ref={firstProvided.innerRef}
                {...firstProvided.droppableProps}
              >
                {(fieldList || []).map((e, i) => {
                  const isBinding = currentBindIndex === i
                  return (
                    <Draggable
                      key={e.slug}
                      draggableId={`draggable-${e.slug}`}
                      index={i}
                    >
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.dragHandleProps}
                          {...provided.draggableProps}
                          className="list-item"
                        >
                          <div
                            className={clsx(
                              'list-contain',
                              curFieldIndex === i && 'active',
                              isBinding && 'binding'
                            )}
                            onClick={() => {
                              onClickField(e, i)
                            }}
                          >
                            <IconMaps
                              type="normalFieldIcon"
                              width={14}
                              height={14}
                            />
                            <span className="list-text">
                              {e.title || '暂无'}
                            </span>
                            {isBinding && (
                              <IconMaps
                                type="greenRightIcon"
                                width={16}
                                height={16}
                              />
                            )}
                          </div>
                          {onBindFuns && (
                            <Tooltip
                              wrapLines
                              width={200}
                              withArrow
                              transition="fade"
                              transitionDuration={200}
                              label={bindTip}
                              disabled={!bindTip}
                              // styles={{
                              //   arrow: { backgroundColor: 'white' },
                              //   body: { backgroundColor: 'white' ,color:'var(--ow-color-gray-100)'},
                              // }}
                            >
                              {isBinding ? (
                                UnBindComp(
                                  isShowUnBindIcon,
                                  onItemUnBind,
                                  fieldList,
                                  i
                                )
                              ) : (
                                <div
                                  className={`list-bind ${
                                    bindTip ? 'point-able' : ''
                                  }`}
                                  onClick={() => {
                                    onItemBind(fieldList[i])
                                  }}
                                >
                                  <div
                                    className={`list-bind-normal ${
                                      bindTip ? 'point-able' : ''
                                    }`}
                                  >
                                    <IconMaps type="linkNormalIcon" size="md" />
                                  </div>
                                  <div
                                    className={`list-bind-hover link-bg ${
                                      bindTip ? 'point-able' : ''
                                    }`}
                                  >
                                    <IconMaps type="linkIcon" size="md" />
                                  </div>
                                </div>
                              )}
                            </Tooltip>
                          )}
                          {provided.placeholder}
                        </div>
                      )}
                    </Draggable>
                  )
                })}
                {firstProvided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
      <div
        className="add-field"
        onClick={() => {
          onOpenCreatePage()
        }}
      >
        <IconMaps
          type="addBoldIcon"
          width={24}
          height={24}
          fill="rgb(1, 82, 217)"
        />
        <span>添加表单项</span>
      </div>
    </ListBox>
  )
}

export default FieldsList
